<template>
  <div class="monthly-talks">
    <div>
      <div class="container-2 w-container">
        <div class="w-layout-grid grid">
          <div id="w-node-f46b2e14a30d-0b455752" class="buttons-container">
            <div
              class="add-event-button showCursorPointer"
              @click="showImageUpload = true"
            >
              <div class="button-text">Upload New Image</div>
            </div>
          </div>
          <div
            id="calendar-container"
            class="calendar-container w-node-d0d89aa4cc2d-0b455752"
            style="background-color:transparent"
          >
          
            <v-img
              contain
              :src="imageURL.url" 
              @load="imageLoaded()"
            > <v-progress-circular
           v-if="!isImageLoaded"
      indeterminate
      color="primary"
    ></v-progress-circular></v-img>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="showImageUpload">
      <image-upload-card
        :multiple="false"
        @save="saveImages"
        @discard="discardClicked"
        
      />
    </v-dialog>
    <v-snackbar v-model="openSnackBar" :color="snackBarColor" timeout="2000">
      <v-row class="pa-0">
        <v-col class="text-center pa-0">{{ snackBarText }}</v-col>
      </v-row>
    </v-snackbar>
  </div>
</template>

<script>
// @ is an alias to /src

import ImageUploadCard from "../components/Events/ImageUploadCard";
export default {
  name: "Monthly-Talks",
  components: {
    ImageUploadCard,
  },
  data() {
    return {
      showImageUpload: false,
      images: [],
      openSnackBar: false,
      snackBarColor: "green",
      snackBarText: "",
      imageURL: "",
      isImageLoaded: false
    };
  },
  async mounted() {
      console.log("Getting images")
    await this.getMonthlyTalksImageUrl();
      console.log("Got image", this.imageURL.url)
  },
  methods: {
    async getMonthlyTalksImageUrl() {
      console.log("Getting images")
      this.imageURL = await this.$store.dispatch("getMonthlyTalksImageURL");
    },
    async saveImages(imageList) {
      this.images = imageList;
      this.imageURL = await this.$store.dispatch("saveMonthlyTalksImage", this.images[0]);
      console.log("Got image", this.imageURL)
      this.showImageUpload = false;
      this.showSnackBar({
        snackBarText: "Images modified",
        snackBarColor: "green",
      });
    },
    showSnackBar({ snackBarText, snackBarColor }) {
      this.snackBarText = snackBarText;
      this.snackBarColor = snackBarColor;
      this.openSnackBar = true;
    },
    discardClicked() {
      this.showImageUpload = false;
    },
    imageLoaded() {
      console.log("Image loaded")
      this.isImageLoaded = true
    }
  },
};
</script>
<style>
.calendar-container .v-image__image {
  height: 70vh !important;
}
</style>
